import React, { useState, useEffect } from "react";
import useUserBundle from "../bundle/userbundle/useUserBundle";

import toast from "react-hot-toast";
import {
  useParams,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import { getProductBundles } from "../../../services/bundle";
import { API } from "../../../config";
import useCart from "../../userDashboard/cart/useCart";
import useGuestCart from "../../userDashboard/cart/useGuestCart";
import { useAuth } from "../../../utils/AuthContext";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import useAddress from "../../userDashboard/address/useAddress";
import useBundleLogic from "./useBundleLogic";

const Bundle = () => {
  const { bundles } = useBundleLogic();
  console.log(bundles);
  const { productId: rproductId } = useParams();
  const navigate = useHistory();
  const {
    handleCreateOrder,
    productBundles,
    calculateBundlePrice,
    isCreatingOrder,
  } = useBundleLogic();

  // console.log("product bundles: ", productBundles);

  // const handleBundleAction = async (bundle) => {
  //   try {
  //     if (isLoggedIn) {
  //       handleCreateOrder(selectedAddress);

  //       // Calculate bundle discount
  //       // const prices = calculateBundlePrice(bundle);
  //       // const discountPerProduct =
  //       //   (prices.original - prices.discounted) / bundle.products.length;

  //       // For authenticated users, add each product individually to cart sequentially
  //       // for (const prod of bundle.products) {
  //       //   // Calculate discounted price for this product
  //       //   const originalPrice = prod.product.price;
  //       //   const discountedPrice = Math.max(
  //       //     originalPrice - discountPerProduct,
  //       //     0
  //       //   );

  //       // Use the async version to properly await each addition
  //       // await addItemToCartAsync({
  //       //   productId: prod.product._id,
  //       //   quantity: prod.quantity,
  //       //   bundleDiscount: discountPerProduct, // Pass bundle discount to backend
  //       // });

  //       // console.log(
  //       //   "Successfully added:",
  //       //   prod.product.name,
  //       //   "at discounted price:",
  //       //   discountedPrice
  //       // );

  //       // Wait a bit to ensure the cart is updated
  //       // await new Promise((resolve) => setTimeout(resolve, 300));
  //       // }
  //       // toast.success("Bundle products added to cart!");
  //       navigate.push("/cart");
  //     } else {
  //       // For guest users, add each product individually to cart with discounted prices
  //       const prices = calculateBundlePrice(bundle);
  //       const discountPerProduct =
  //         (prices.original - prices.discounted) / bundle.products.length;

  //       bundle.products.forEach((prod) => {
  //         const originalPrice = prod.product.price;
  //         const discountedPrice = Math.max(
  //           originalPrice - discountPerProduct,
  //           0
  //         );

  //         addToCart({
  //           productId: prod.product._id,
  //           quantity: prod.quantity,
  //           price: discountedPrice, // Use discounted price
  //         });
  //       });
  //       toast.success("Bundle products added to cart!");
  //       navigate.push("/cart");
  //     }
  //   } catch (error) {
  //     console.log("error: ", error);
  //     toast.error(error?.response?.data?.message || "Failed to add to cart");
  //   }
  // };

  // const isBundleInCart = (bundle) => {
  //   if (isLoggedIn) {
  //     // Check if all products in the bundle are in cart
  //     return bundle.products.every((prod) =>
  //       cartItems?.items?.some((item) => item?.productId === prod.product._id)
  //     );
  //   } else {
  //     // For guest users, check if all products are in cart
  //     return bundle.products.every((prod) => isInCart(prod.product._id));
  //   }
  // };

  // const calculateBundlePrice = (bundle) => {
  //   const totalOriginalPrice = bundle.products.reduce((total, prod) => {
  //     return total + prod.product.price * prod.quantity;
  //   }, 0);

  //   let discountedPrice = totalOriginalPrice;
  //   if (bundle.discountType === "percentage") {
  //     discountedPrice =
  //       totalOriginalPrice - (totalOriginalPrice * bundle.discountValue) / 100;
  //   } else {
  //     discountedPrice = totalOriginalPrice - bundle.discountValue;
  //   }

  //   return {
  //     original: totalOriginalPrice,
  //     discounted: Math.max(discountedPrice, 0),
  //   };
  // };

  // if (isGettingProductBundles) {
  //   return (
  //     <div className="container py-8">
  //       <div className="flex items-center justify-center flex-col min-h-[200px]">
  //         <CustomLoading />
  //         <span>Loading Bundles...</span>
  //       </div>
  //     </div>
  //   );
  // }

  // if (errorGettingProductBundles) {
  //   return (
  //     <div className="">
  //       {/* <div className="text-center text-red-600">error getting bundles</div> */}
  //     </div>
  //   );
  // }

  // if (!productBundles || productBundles.length === 0) {
  //   return null; // Don't render anything if no bundles
  // }

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 py-12">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#D80B0E] rounded-full mb-4">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
              />
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Special Bundle Offers
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get more value for your money with our exclusive product bundles.
            Save big when you buy these items together!
          </p>
        </div>

        {/* Bundles Grid - Landscape Layout */}
        {bundles && (
          <div className="grid gap-6 grid-cols-1">
            {bundles?.map((bundle) => {
              const prices = calculateBundlePrice(bundle);
              // const isInCart = isBundleInCart(bundle);
              const savings = Math.floor(prices.original - prices.discounted);
              const savingsPercentage = Math.round(
                (savings / prices.original) * 100
              );

              return (
                <div
                  key={bundle._id}
                  className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100"
                >
                  {/* Savings Badge */}
                  <div className="absolute top-4 right-4 z-10">
                    <div className="bg-gradient-to-r from-[#D80B0E] to-[#e03c3e] text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                      Save {savingsPercentage}%
                    </div>
                  </div>

                  {/* Landscape Layout */}
                  <div className="flex flex-col md:flex-row">
                    {/* Left Side - Bundle Info */}
                    <div className="flex-1 p-6">
                      <div className="mb-4">
                        <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#D80B0E] transition-colors">
                          {bundle.title}
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed mb-4">
                          {bundle.description}
                        </p>
                      </div>

                      {/* Products Section - Horizontal Layout */}
                      <div className="mb-4">
                        <h4 className="text-sm font-semibold text-gray-700 mb-3">
                          Bundle Contents:
                        </h4>
                        <div className="flex flex-wrap gap-3">
                          {bundle?.products?.map((prod, idx) => (
                            <div
                              key={idx}
                              className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg"
                            >
                              <div className="relative">
                                <img
                                  src={`${API}/${prod?.product?.photo}`}
                                  alt={prod?.product?.name}
                                  className="w-10 h-10 object-cover rounded-md border border-white shadow-sm"
                                />
                                <div className="absolute -top-1 -right-1 bg-[#D80B0E] text-white text-xs rounded-full w-4 h-4 flex items-center justify-center font-bold">
                                  {prod?.quantity}
                                </div>
                              </div>
                              <div>
                                <h5 className="font-semibold text-gray-900 text-sm">
                                  {prod?.product?.name}
                                </h5>
                                <p className="text-xs text-gray-500">
                                  {Math.floor(prod?.product?.price)} EGP each
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Date Range */}
                      <div className="flex items-center gap-2 text-xs text-gray-500">
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                        <span>
                          Valid until{" "}
                          {new Date(bundle.endDate).toLocaleDateString()}
                        </span>
                      </div>
                    </div>

                    {/* Right Side - Pricing and Action */}
                    <div className="md:w-80 bg-gradient-to-r from-gray-50 to-gray-100 p-6 flex flex-col justify-between">
                      {/* Pricing Section */}
                      <div className="mb-6">
                        <div className="text-center mb-4">
                          <div className="text-3xl font-bold text-[#D80B0E] mb-2">
                            {Math.floor(prices.discounted)} EGP
                          </div>
                          <div className="text-sm text-gray-500 line-through">
                            {Math.floor(prices.original)} EGP
                          </div>
                        </div>

                        <div className="text-center">
                          <div className="text-lg font-semibold text-green-600 mb-1">
                            Save {savings} EGP
                          </div>
                          <div className="text-xs text-gray-500">
                            {bundle.discountType === "percentage"
                              ? `${bundle.discountValue}% off`
                              : `${bundle.discountValue} EGP off`}
                          </div>
                        </div>
                      </div>

                      {/* Action Button */}
                      <button
                        onClick={() => handleCreateOrder()}
                        disabled={isCreatingOrder}
                        className={`w-full py-3 px-6 rounded-xl font-semibold text-white transition-all duration-300 transform hover:scale-105 bg-gradient-to-r from-[#D80B0E] to-[#e03c3e] hover:from-[#e03c3e] hover:to-[#D80B0E] shadow-lg"} disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none`}
                      >
                        {isCreatingOrder ? (
                          <span className="flex items-center justify-center">
                            <CustomLoading size="1rem" color="#fff" />
                            <span className="ml-2">Processing...</span>
                          </span>
                        ) : (
                          <span className="flex items-center justify-center">
                            <svg
                              className="w-5 h-5 mr-2"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m6 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01"
                              />
                            </svg>
                            Order Now
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Bundle;
